/**
 * DuckDB型名マッピングユーティリティ
 *
 * MIDASのDataTypeとDuckDBのSQL型名の対応を管理
 */

import { DataType } from '../../types/core.types';

/**
 * MIDASのDataType → DuckDBのSQL型名のマッピング
 */
export const DUCKDB_TYPE_MAP: Record<DataType, string> = {
  'boolean': 'BOOLEAN',
  'int64': 'BIGINT',
  'float64': 'DOUBLE',
  'date': 'DATE',
  'datetime': 'TIMESTAMP',
  'string': 'VARCHAR'
};

/**
 * MIDASのDataTypeをDuckDBのSQL型名に変換
 *
 * @param dataType - MIDASのデータ型
 * @returns DuckDBのSQL型名
 * @throws Error - 未知の型の場合
 */
export function toDuckDBType(dataType: DataType): string {
  const duckdbType = DUCKDB_TYPE_MAP[dataType];

  if (!duckdbType) {
    throw new Error(`Unknown data type: ${dataType}`);
  }

  return duckdbType;
}

/**
 * DuckDBのSQL型名をMIDASのDataTypeに逆変換
 *
 * @param duckdbType - DuckDBのSQL型名
 * @returns MIDASのデータ型（複数の可能性がある場合は最初の候補）
 */
export function fromDuckDBType(duckdbType: string): DataType | null {
  const normalized = duckdbType.toUpperCase();

  for (const [midasType, dbType] of Object.entries(DUCKDB_TYPE_MAP)) {
    if (dbType === normalized) {
      return midasType as DataType;
    }
  }

  return null;
}
